export const PUBLIC_ROUTES = [
  '/app/login',
  '/feedback-collect',
  '/visitor-registration',
  '/visitor-pass',
  '/service-desk',
  '/survey-collect',
  '/forgot-password',
  '/reset-password',
]
  
export const isPwaEnabled = path => {
  return !PUBLIC_ROUTES.some(route => path.startsWith(route))
}

/**
 * The scope the bedside concierge's own push worker registers at.
 *
 * Shared by the registration (ConciergeChat) and the guard that unregisters
 * workers on public routes: the guard must spare this one, and it identifies
 * it by scope. Keeping the string in one place is what stops the two drifting
 * apart -- if they ever disagree, patient notifications stop arriving with no
 * error anywhere.
 */
export const CONCIERGE_SW_SCOPE = '/service-desk/chat'
